module.exports = __webpack_public_path__ + "img/login.8d5f944b.svg";